import React, { useMemo } from 'react';
import { Select, SelectProps } from '@app/form';
import { useCurrentOrganizationId, useOrganizationMembers } from '../queries';

interface Props extends SelectProps {
  selectionType: 'clientId' | 'accountId';
  organizationId?: string;
}

export const OrganizationMemberSelect = ({
  selectionType = 'clientId',
  organizationId,
  ...selectProps
}: Props) => {
  const currentOrganization = useCurrentOrganizationId();
  const { data: members } = useOrganizationMembers(
    organizationId || currentOrganization,
  );

  const options = useMemo(() => {
    if (!members) {
      return [];
    }
    return members.map(({ account, id }) => ({
      label: [account.firstName, account.lastName].filter(Boolean).join(' '),
      value: selectionType === 'clientId' ? id : account.id,
    }));
  }, [selectionType, members]);

  return <Select {...selectProps} options={options} />;
};
